import { Suspense } from 'react';

import { useSuspenseGetProductOffers } from '../../../api/lending/lapiHooks.suspense';
import { LoadingCard } from '../../components/LoadingCard/LoadingCard';

function InvoiceFinanceSignupContent() {
  const { productOffers } = useSuspenseGetProductOffers();

  return (
    <div className="grid gap-l">
      <h1 className="text-xl font-bold">
        Invoice Finance Signup (Placeholder)
      </h1>
      <p>Product offers response:</p>
      <pre className="overflow-auto rounded-xs bg-structure-95 p-m text-s">
        {JSON.stringify(productOffers, null, 2)}
      </pre>
    </div>
  );
}

export function InvoiceFinanceSignup() {
  return (
    <Suspense fallback={<LoadingCard />}>
      <InvoiceFinanceSignupContent />
    </Suspense>
  );
}
